import { api } from '~/data/api'
import { ICompany, IContactInfo } from '~/utils/types'

export interface IDeleteCompanyPhotoProps {
  company_id?: string
}

export interface IUpdateCompanyProps {
  company_id?: string
  company: ICompany
}
export interface IUpdateCompanyPhotoProps {
  company_id: string
  photo: File
}

export async function getCompanyImage(company_id: string): Promise<{ photo_url: ICompany['photo_url'] }> {
  const response = await api().get(`/company/${company_id}/find_photo`)
  return response.data
}

export async function deleteCompanyImage({ company_id }: IDeleteCompanyPhotoProps) {
  return await api().delete(`/company/${company_id}/delete_photo`)
}

export async function updateCompany({ company_id, company }: IUpdateCompanyProps) {
  const company_photo = company.photo
  if (company_photo && company_id) {
    const photoUploaded = await updateCompanyPhoto({ company_id, photo: company_photo })
    if (photoUploaded.status === 200) {
      company.photo_key = photoUploaded.data.photo_key
    }
  } else if (company_photo === null) {
    const deleted = await deleteCompanyImage({ company_id })
    if (Object.keys(company).length === 1) {
      return deleted.data
    }
  }
  delete company.photo
  if (Object.keys(company).length > 0) {
    const response = await api().put(`/company/${company_id}`, company)
    return response.data
  }

}

export async function updateCompanyPhoto({ company_id, photo }: IUpdateCompanyPhotoProps) {
  const formData = new FormData()
  formData.append('company_photo', photo)

  return await api().put(`/company/${company_id}/import_photo`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export async function createCompany(company: ICompany) {
  const company_photo = company.photo
  delete company.photo
  const response = await api().post(`/company`, company)
  if (response.status === 200 && company_photo) {
    await updateCompanyPhoto({ company_id: response.data._id, photo: company_photo })
  }
  return response.data
}

export async function deleteCompany(company_id: string) {
  const response = await api().delete(`/company/${company_id}`)
  return response.data
}

export async function getCompanyContactInfo(company_id: string): Promise<IContactInfo[]> {
  const response = await api().get(`/company/${company_id}`)

  return (response.data as ICompany).contact_info
}

export const listCompanies = async (): Promise<ICompany[]> => {
  const response = await api().get('/company')
  return response.data
}